import React, { useState, Suspense } from 'react';
import {
  TabButtonStyled,
  ProjectAdminContainerStyled,
  ProjectAdminHeaderStyled,
  ProjectAdminTabStyled,
} from '../styled';
import { Text, Spinner, SpinnerSize } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { weldSetupAdminTabList } from './tab-data';
import { WeldSetupAdminTab, WeldSetupAdminTabType } from './types';
import { useLingui } from '@lingui/react';
import { map } from 'lodash';
import { ErrorBoundary } from '@bechtel/client-common';
import { PipingWeldSetup } from './piping';

export const WeldSetup = () => {
  const [selectedTab, setSelectedTab] = useState<WeldSetupAdminTabType>(WeldSetupAdminTabType.PIPING);
  const { i18n } = useLingui();
  return (
    <ProjectAdminContainerStyled data-testid="weld-setup-container">
      <ProjectAdminHeaderStyled data-testid="weld-setup-header">
        <Text family="graphik" size="600" weight="600" color="white">
          <Trans>Weld Setup</Trans>
        </Text>
      </ProjectAdminHeaderStyled>
      <ProjectAdminTabStyled>
        {map(weldSetupAdminTabList, (tabItem: WeldSetupAdminTab) => {
          return (
            <TabButtonStyled
              data-testid="weld-setup-tab"
              selected={tabItem.value === selectedTab}
              onClick={() => {
                setSelectedTab(tabItem.value);
              }}
              key={tabItem.value}
            >
              {i18n._(tabItem.label)}
            </TabButtonStyled>
          );
        })}
      </ProjectAdminTabStyled>
      {selectedTab == WeldSetupAdminTabType.PIPING && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <PipingWeldSetup />
          </Suspense>
        </ErrorBoundary>
      )}
      {selectedTab == WeldSetupAdminTabType.STRUCTURAL && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <PipingWeldSetup />
          </Suspense>
        </ErrorBoundary>
      )}
    </ProjectAdminContainerStyled>
  );
};
